export default {"src":"/_next/static/media/vote.32e23033.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};